var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useState, useEffect } from "react";
import Modal from "@widget/popups/Modal";
import Input from "@widget/forms/inputs/Input";
import ButtonComponent from "@widget/buttons/ButtonComponent";
import FormField from "@widget/forms/inputs/FormField";
import RecaptchaField from "@widget/forms/inputs/RecaptchaField";
import { sendPasswordResetRequest } from "@core/services/auth_services";
import { $L } from "../utils/authLocalization";
const ForgotPassword = ({ show, onClose, accountUrl, captchaEnabled, captchaSiteKey, currentLanguage }) => {
    const [loginID, setLoginID] = useState('');
    const [success, setSuccess] = useState(false);
    const [error, setError] = useState('');
    const [loading, setLoading] = useState(false);
    const [captchaResponse, setCaptchaResponse] = useState('');
    // Reset captcha state when modal closes
    useEffect(() => {
        if (!show) {
            setCaptchaResponse('');
        }
    }, [show]);
    const handleSubmit = () => __awaiter(void 0, void 0, void 0, function* () {
        if (!loginID) {
            setError($L('uxp-core.auth.enter-user-id', currentLanguage));
            return;
        }
        if (captchaEnabled && !captchaResponse) {
            setError($L('uxp-core.auth.complete-recaptcha', currentLanguage));
            return;
        }
        setError('');
        setLoading(true);
        try {
            const result = yield sendPasswordResetRequest({
                LoginID: loginID,
                captcha: captchaResponse
            }, accountUrl);
            if (result.successful) {
                setSuccess(true);
                setError('');
                setLoading(false);
            }
            else {
                setError($L('uxp-core.auth.forgot-password-failed', currentLanguage));
                setLoading(false);
            }
        }
        catch (err) {
            setError($L('uxp-core.auth.forgot-password-failed', currentLanguage));
            setLoading(false);
        }
    });
    const handleClose = () => {
        setLoginID('');
        setSuccess(false);
        setError('');
        setLoading(false);
        setCaptchaResponse('');
        onClose();
    };
    // Determine if form can be submitted
    const canSubmit = loginID && !loading && (!captchaEnabled || captchaResponse);
    return (_jsx(Modal, { show: show, onClose: handleClose, title: $L('uxp-core.auth.reset-password', currentLanguage), showCloseButton: true, className: "uxpcore_modal--auth", autoSize: true, children: !success ? (_jsxs("div", { className: "uxpcore_forgot_password__form", children: [_jsx("div", { className: "uxpcore_forgot_password__description", children: captchaEnabled
                        ? $L('uxp-core.auth.forgot-password-description-with-captcha', currentLanguage)
                        : $L('uxp-core.auth.forgot-password-description', currentLanguage) }), _jsxs("div", { className: "uxpcore_forgot_password__form-fields", children: [_jsx(FormField, { children: _jsx(Input, { value: loginID, onChange: setLoginID, placeholder: $L('uxp-core.auth.user-id', currentLanguage), fullWidth: true }) }), captchaEnabled && captchaSiteKey && (_jsx(FormField, { children: _jsx(RecaptchaField, { siteKey: captchaSiteKey, enabled: captchaEnabled, onChange: (token) => setCaptchaResponse(token) }) })), error && (_jsx("div", { className: "uxpcore_forgot_password__error-message", children: error }))] }), _jsxs("div", { className: "uxpcore_forgot_password__actions", children: [_jsx(ButtonComponent, { title: $L('uxp-core.auth.cancel', currentLanguage), onClick: handleClose, className: "uxpcore_forgot_password__cancel-btn", variant: 'secondary' }), _jsx(ButtonComponent, { title: $L('uxp-core.auth.submit', currentLanguage), loadingTitle: $L('uxp-core.auth.sending', currentLanguage), loading: loading, onClick: handleSubmit, disabled: !canSubmit, className: "uxpcore_forgot_password__submit-btn" })] })] })) : (_jsxs("div", { className: "uxpcore_forgot_password__form", children: [_jsx("div", { className: "uxpcore_forgot_password__success-message", children: $L('uxp-core.auth.reset-password-success', currentLanguage) }), _jsx("div", { className: "uxpcore_forgot_password__description", children: $L('uxp-core.auth.reset-password-instruction', currentLanguage) }), _jsx("div", { className: "uxpcore_forgot_password__actions", children: _jsx(ButtonComponent, { title: $L('uxp-core.text.close', currentLanguage), onClick: handleClose, className: "uxpcore_forgot_password__close-btn" }) })] })) }));
};
export default ForgotPassword;
